<template>
  <div id="faz-mapbox-scrollytelling">
    <div class="main__graphic" v-if="config">
      <div :id="'mapboxContainer-'+id" class="mapbox"></div>
      <Transition>
      <div v-if="config.minimap && currStep && currStep.minimap" class="minimap">
        <LocatorMap
          :geoJson="config.minimap"
          :maxHeight="150"
          :markers="[{
            'lat':currStep.location.center[0],
            'long':currStep.location.center[1],
            'label':''}]"
        />
          <!-- :data="mapData"
          :options="mapSettings"
          v-model="selectedRegion"
          :year="'2021'" -->
      </div>
      </Transition>
    </div>

    <div v-if="config.intro" class="scrollytelling_intro">
      <div>
        <h2 class="kicker">{{config.intro.kicker}}</h2>
        <h1 class="headline" v-html="config.intro.headline"></h1>
        <div class="authors" v-html="config.intro.authors"></div>
        <div class="date">{{config.intro.date}}</div>
      </div>
    </div>
    
    <Scrollama
      v-if="config"
      :debug="false"
      container=".storyContainer"
      @step-enter="onStepEnter"
      @step-exit="onStepExit"
    >
      <div v-for="(chapter, index) in config.chapters" :key="index" class="step" :class="chapter.alignment" :data-step-no="index" :id="chapter.id">
        <div v-if="chapter.description">
          <div class="title" v-if="chapter.title" v-html="chapter.title"></div>
          <div class="description" v-if="chapter.description.length>1" v-html="chapter.description"></div>
          <div class="image" v-if="chapter.image">
            <img  :src="chapter.image" />
            <div class="image_caption" v-if="chapter.image_caption">
              {{chapter.image_caption}}
              <span class="image_source" v-if="chapter.image_source">{{chapter.image_source}}</span>
            </div>
          </div>
        </div>
      </div>
    </Scrollama>
  </div>
</template>

<script>
import 'intersection-observer' // for cross-browser support
import Scrollama from 'vue-scrollama' // local registration in this example, can also be globally registered
import mapboxgl from "!mapbox-gl"
// import config from "./config.js"
import LocatorMap from './components/LocatorMap.vue'

export default {
  name: 'App',
  components: {
    Scrollama,
    LocatorMap
  },
  props: ['id'],
  data() {
    return {
      map: null,
      currStep: null,
      config: null,
      width: 500,
      markers: [],
      layerTypes: {
        'fill': ['fill-opacity'],
        'line': ['line-opacity'],
        'circle': ['circle-opacity', 'circle-stroke-opacity'],
        'symbol': ['icon-opacity', 'text-opacity'],
        'raster': ['raster-opacity'],
        'fill-extrusion': ['fill-extrusion-opacity'],
        'heatmap': ['heatmap-opacity']
      },
      layerTypes2: {
        'fill': ['fill-color'],
        'line': ['line-opacity'],
        'circle': ['circle-opacity', 'circle-stroke-opacity'],
        'symbol': ['icon-opacity', 'text-opacity'],
        'raster': ['raster-opacity'],
        'fill-extrusion': ['fill-extrusion-opacity'],
        'heatmap': ['heatmap-opacity']
      }
    }
  },
  methods: {
    stepEnterHandler () {
      // {element, index, direction}
      // handle the step-event as required here
      // console.log({ element, index, direction });
      // use the data attributes if needed
      // console.log(element.dataset.step) // a, b or c 
    },
    onStepEnter ({element}) {
      // console.log({ element, index, direction })
      let chapter = this.config.chapters.find(chap => chap.id === element.id)
      this.currStep = chapter
      element.classList.add('active')

      this.map.flyTo({
        center: chapter.location.center,
        zoom: chapter.location.zoom * this.zoomFactor,
        pitch: chapter.location.pitch,
        bearing: chapter.location.bearing,
        speed: 1,
        curve: 1
      })

      if (chapter.markers) {
        console.log(chapter.markers)

        // const el = document.createElement('div');
        // el.innerHTML = chapter.markers[0].label
        // el.className = 'marker'
        // new mapboxgl.Marker(el)
        //  .setLngLat(chapter.markers[0].location)
        //  .addTo(this.map);
        chapter.markers.forEach( marker => {
          let el = document.createElement('div');
          el.innerHTML = marker.label
          el.className = 'marker'
          let m = new mapboxgl.Marker(el)
            .setLngLat(marker.location)
            .addTo(this.map);
          this.markers.push(m)
        })
      }

      if (chapter.marker) {
        // console.log(chapter.marker, chapter.location.center)
        // var marker = new mapboxgl.Marker({ color: '#c60000' });
        // marker.setLngLat(chapter.location.center).addTo(this.map);

        const el = document.createElement('div');
        el.innerHTML = chapter.marker
        el.className = 'marker'
        new mapboxgl.Marker(el)
         .setLngLat(chapter.location.center)
         .addTo(this.map);
        
        // this.map.addSource('khjgfjhgfju', {
        //   "type": "geojson",
        //   "data": {
        //     "type": "Feature",
        //     "geometry": {
        //       "type": "Point",
        //       "coordinates": chapter.location.center
        //     },
        //     "properties": {
        //       "description": chapter.marker,
        //       "icon": "dot-10"
        //     }
        //   }
        // })
        // this.map.addLayer({
        //     'id': 'khjgfjhgfju',
        //     'type': 'symbol',
        //     'source': 'places',
        //     'layout': {
        //         'text-field': ['get', 'description'],
        //         'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
        //         'text-radial-offset': 0.5,
        //         'text-justify': 'auto',
        //         'icon-image': ['concat', ['get', 'icon'], '-15']
        //     }
        // });
      }

      // if (chapter.landkreis) {
      //   // console.log(chapter.landkreis)
      //   this.map.setFilter('landkreise', ['==', ['get', 'krs_code'], chapter.landkreis])
      //   setTimeout(() => {
      //     this.map.setPaintProperty('landkreise', 'line-opacity', 1)
      //   }, 500)
      // } else {
      //   // console.log('no lkrs')
      //   this.map.setPaintProperty('landkreise', 'line-opacity', 0)
      // }

      // if (config.showMarkers) {
      //     marker.setLngLat(chapter.location.center);
      // }
      if (chapter.onChapterEnter.length > 0) {
        chapter.onChapterEnter.forEach(this.setLayerOpacity)
      }

      // if (chapter.callback) {
      //     window[chapter.callback]();
      // }
      // if (chapter.rotateAnimation) {
      //     map.once('moveend', function() {
      //         const rotateNumber = map.getBearing();
      //         map.rotateTo(rotateNumber + 90, {
      //             duration: 24000, easing: function (t) {
      //                 return t;
      //             }
      //         });
      //     });
      // }
    },
    onStepExit ({element}) {
      // console.log({ element, index, direction })
      let chapter = this.config.chapters.find(chap => chap.id === element.id)
      element.classList.remove('active')
      if (chapter.onChapterExit.length > 0) {
          chapter.onChapterExit.forEach(this.setLayerOpacity)
      }
      if (chapter.markers) {
        this.markers.forEach( marker => {
          marker.remove()
        })
      }
    },
    getLayerPaintType(layer) {
      if (!this.map.getLayer(layer)) {
        return null
      } else {
        let layerType = this.map.getLayer(layer).type
        return this.layerTypes[layerType]
      }
    },
    setLayerOpacity (layer) {
      var paintProps = this.getLayerPaintType(layer.layer)
      
      if(paintProps) {
        paintProps.forEach( (prop) => {
            var options = {};
            if (layer.duration) {
                var transitionProp = prop + "-transition"
                options = { "duration": layer.duration }
                this.map.setPaintProperty(layer.layer, transitionProp, options)
            }
            // console.log(layer.layer, prop, layer.opacity, options)
            this.map.setPaintProperty(layer.layer, prop, layer.opacity, options)
        })
      }
      // console.log(layer.layer, layer.color)
      if(layer.color) {
        this.map.setPaintProperty(layer.layer, 'fill-color', layer.color)
      }
    }
  },
  computed: {
    zoomFactor () {
      return this.width > 600 ? 1 : 0.9
    }
  },
  mounted () {
    mapboxgl.accessToken = 'pk.eyJ1IjoiamVuc2dpZXNlbCIsImEiOiJja3FhcGcyM28wZmF4MnRsOXZtNnFxejBrIn0.W83tjxWJI1M0uVFYf2EBLg'

    this.width = window.innerWidth

    let configUrl = process.env.NODE_ENV == 'development' ? 
      'scrollytelling-intro/config.json' :
      document.getElementById('config-'+this.id).dataset.config

    // console.log(document.getElementById('config-'+this.id))

    fetch(configUrl)
      .then(r => r.json())
      .then(r => this.config = r)
      .then( () => {
        let location = null
        if (this.config.intro && this.config.intro.location) {
          location = this.config.intro.location
        } else {
          location = this.config.chapters[0].location
        }

        this.map = new mapboxgl.Map({
          container: "mapboxContainer-"+this.id,
          style: this.config.style+"?optimize=true", 
          center: location.center,
          zoom: location.zoom * this.zoomFactor,
          bearing: location.bearing,
          pitch: location.pitch,
          interactive: false,
        })
      })
  }
}
</script>

<style lang="scss">
@import './assets/mapbox-gl.css';

.storyContainer .grid.grid-center .col-6_xs-11 {
  width: 100%;
  max-width: 700px;
  flex-basis: 100%;
  font-size: 18px;
  line-height: 1.5;
  padding-left: 20px;
  padding-right: 20px;
}

#faz-mapbox-scrollytelling {
  font-family: 'FAZGoldSans', Verdana, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  background: #333;

  * {
    box-sizing: border-box;
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

  .floatingTeaser {
    display: block;
    clear: left;
    float: right;
    margin-right: -20.8333333333%;
    margin-left: 1rem;
    margin-top: 5px;
    width: 41.6666666667%;
    margin-bottom: 1rem;
    //@errorborder: 1px solid #ddd;
    border-radius: 3px;
    overflow: hidden;
    text-decoration: none;
    line-height: 1.3;
    background-color: #efefef;
    transition: all .5s;

    &:hover {
      transform: scale(1.03);
      
      .hl {
        color: #c60000;
      }
    }

    img {
      display: block;
      width: 100%;
    }

    .dz {
      color: #666;
      font-size: 13px;
      text-transform: uppercase;
      padding: 10px;
      padding-bottom: 5px;
    }

    .hl {
      font-weight: bold;
      padding: 10px;
      padding-top: 0;
    }

    @media screen and (max-width: 940px) {
      margin: 0;
      width: 100%;
      margin-bottom: 2rem;
    }
  }

  .intro,
  .outro {
    padding: 20vh;
  }

  .main__graphic {
    position: sticky;
    top: 0;
    height: 100vh;
    border: 1px solid #ccc;
    background-color: #eee;
    font-size: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .minimap {
      position: absolute;
      bottom: 40px;
      left: 10px;
      width: 150px;
    }
  }

  .scrollytelling_intro {
    position: absolute; 
    top: 0; 
    left: 0;
    color: #fff;
    text-align: center;
    width: 100%;
    height: 100vh;
    // background: rgba(0,0,0,.33);
    margin-bottom: 200px;
    padding: 200px 15px;
    font-size: 18px;
    line-height: 1.4;
    text-shadow: 0px 0px 5px #000000;
    transform: translate3d(0,0,0);

    > div {
      max-width: 600px;
      margin: auto;
    }

    .kicker {
      text-transform: uppercase;
      letter-spacing: 0.1em;
      font-size: 18px;
      line-height: 1.4;
      font-weight: normal;
      // color: #999;
      padding: 0;
      margin-bottom: .5em;
    }

    .headline {
      font-size: 72px;
      line-height: 1.1;
      font-family: Georgia, serif;
      font-weight: normal;
      margin-top: 0;
      margin-bottom: .5em;
      padding: 0;

      @media screen and (max-width: 600px) {
        font-size: 50px;
      }
    }

    .authors {
      margin-bottom: 1em;

      a {
        color: unset;
        text-decoration: none;
        font-weight: bold;

        &:hover {
          color: #efefef;
        }
      }
    }

    .date {
      text-align: center;
    }
  }

  .scrollama__steps {
    position: relative;
    overflow: hidden;
  }

  .step {
    width: 30vw;
    margin-left: 62vw;
    padding-bottom: 50vh;
    padding-top: 30vh;
    transform: translate3d(0,0,0);
    //opacity: 0.7;
    z-index: 100;
    transition: opacity .5s;

    @media (max-width: 1000px) {
      width: 100vw !important;
      margin: 0 auto !important;
    }

    &.center {
      width: 50vw;
      margin: 0 auto;
    }
    &.left {
        width: 33vw;
        margin-left: 5vw;
    }
    &.right {
        width: 33vw;
        margin-left: 62vw;
        text-align: left;
        float: unset;
    }
    &.full {
      width: 100%;
      margin: auto;
      background-color: #fff;
      padding-top: 0;
      padding-bottom: 0;
      opacity: 1;
      // margin-bottom: 50px;

      > div {
        color: #333;
        max-width: 700px;
        margin: auto;
        background-color: unset;
      }
    }

    &.active {
      opacity: 1;
    }

    > div {
      padding: 30px;
      color: #efefef;
      font-size: 18px;
      line-height: 1.5;
      background-color: rgba(0,0,0,.75);
      max-width: 700px;
      margin: auto;
      border-radius: 3px;

      @media (max-width: 600px) {
        padding: 20px;
        border-radius: 0;
      }

      .title {
        font-weight: bold;
        padding-bottom: .5em;
      }

      .description{
        span {
          font-weight: bold;
        }

        big {
          font-size: 20px;
        }

        .initial {
          font-weight: normal;
          font-size: 88px;
          line-height: 56px;
          float: left;
          margin: 22px 8px 0px 0;
          text-decoration: none;
        }

        a {
          color: inherit;
        }
      }

      .description + .image {
        margin-top: 15px;
      }

      .image {
        // margin-bottom: 10px;
        color: #999;
        // max-width: 600px;

        img {
          display: block;
          width: 100%;
          margin-bottom: 10px;
        }

        &_caption {
          font-size: 13px;
          line-height: 1.3;
        }

        &_source {
          font-size: 10px;
        } 

      }

    }
  }
  
  .mapbox {
    // position: absolute;
    width: 100%;
    height: 100vh;

    .marker {
      font-family: 'FAZGoldSans', Verdana, Arial, sans-serif;
      color: #fff;
      background-color: rgba(0,0,0,.75);
      padding: .7em;
      border-radius: 3px;
      font-size: 14px;
    }
  }

  /* Fix issue on mobile browser where scroll breaks  */
  .mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate.mapboxgl-touch-drag-pan, 
  .mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate.mapboxgl-touch-drag-pan .mapboxgl-canvas {
      touch-action: unset;
  }

  .mapboxgl-ctrl-attrib-inner {
    font-size: 10px;
  }
}
</style>
